import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPrinter = () => {
  return (
    <g>
      <path d="m15.1406 4.1345h-1.6806v-3.2754a.7.7 0 0 0 -.7-.7h-9.5208a.7.7 0 0 0 -.7.7v3.2754h-1.6798a.7.7 0 0 0 -.7.7v6.9736a.7.7 0 0 0 .7.7h1.68v2.6323a.7.7 0 0 0 .7.7h9.5206a.7.7 0 0 0 .7-.7v-2.6319h1.6807a.7.7 0 0 0 .7-.7v-6.9738a.7.7 0 0 0 -.7001-.7002zm-11.2012-2.5752h8.12v2.5752h-8.12zm8.12 12.8813h-8.12v-4.4106h8.12zm2.3806-3.3324h-.98v-1.7782a.7.7 0 0 0 -.7-.7h-9.52a.7.7 0 0 0 -.7.7v1.7783h-.98v-5.5734h12.88z" />
      <path d="m3.2334 7.7947a.7025.7025 0 0 0 .5-.2.6887.6887 0 0 0 0-.99.7253.7253 0 0 0 -.9893 0 .6887.6887 0 0 0 0 .99.6959.6959 0 0 0 .4893.2z" />
    </g>
  );
};

export default withIcon(IconPrinter);
